import { Parser } from 'json2csv'

export default function (data, options = {
  fields: [],
  filename: 'filename',
  withBOM: true,
  excelStrings: true
}) {
  if (!options.hasOwnProperty('withBOM')) options.withBOM = true
  if (!options.hasOwnProperty('filename')) options.filename = 'filename'
  if (!options.hasOwnProperty('excelStrings')) options.excelStrings = true
  const parser = new Parser(options)
  const csv = parser.parse(data)

  const blob = new Blob([csv], { type: 'text/csv' })

  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, options.filename + '.csv')
  } else {
    const link = document.createElement('a')
    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', options.filename + '.csv')
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
